import { Lumberjack } from '@/Domain/Tracking/Lumberjacks'

export class LumberjackDTO {
    private _nameLumberJack: string
    private _nif: string
    private _ofert: string
    private _state: string

    static fromLumberjack (lumberjack: Lumberjack): LumberjackDTO {
      return new this(
        lumberjack.nameLumberJack(),
        lumberjack.nif(),
        lumberjack.ofert(),
        lumberjack.state()
      )
    }

    constructor (
      nameLumberJack: string,
      nif: string,
      ofert: string,
      state: string
    ) {
      this._nameLumberJack = nameLumberJack
      this._nif = nif
      this._ofert = ofert
      this._state = state
    }

    get nameLumberJack (): string {
      return this._nameLumberJack
    }

    get nif (): string {
      return this._nif
    }

    get ofert (): string {
      return this._ofert
    }

    get state (): string {
      return this._state
    }
}
